/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentBase,
  OrderPaymentBaseOptional,
  OrderPaymentBaseMetaI,
  OrderPaymentBaseTrackedI,
} from "./order-payment-base";
import {
  OrderPaymentBaseTracked,
  OrderPaymentBaseMeta,
} from "./order-payment-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentRef,
  OrderPaymentRefOptional,
  OrderPaymentRefMetaI,
  OrderPaymentRefTrackedI,
} from "./order-payment-ref";
import {
  OrderPaymentRefTracked,
  OrderPaymentRefMeta,
} from "./order-payment-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentWithOrderRef,
  OrderPaymentWithOrderRefOptional,
  OrderPaymentWithOrderRefMetaI,
  OrderPaymentWithOrderRefTrackedI,
} from "./order-payment-with-order-ref";
import {
  OrderPaymentWithOrderRefTracked,
  OrderPaymentWithOrderRefMeta,
} from "./order-payment-with-order-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderRef,
  OrderRefOptional,
  OrderRefMetaI,
  OrderRefTrackedI,
} from "./order-ref";
import { OrderRefTracked, OrderRefMeta } from "./order-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentStatus,
  PaymentStatusOptional,
  PaymentStatusMetaI,
  PaymentStatusTrackedI,
} from "./payment-status";
import { PaymentStatusTracked, PaymentStatusMeta } from "./payment-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface PaymentReportDTO
 */
export interface PaymentReportDTOOptional extends DBHistoryOptional {
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof PaymentReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof PaymentReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof PaymentReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof PaymentReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof PaymentReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  createdBy?: string;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentReportDTO
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof PaymentReportDTO
   */
  paymentStatus?: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof PaymentReportDTO
   */
  expiresOn?: Date;
  /**
   *
   * @type {OrderRef}
   * @memberof PaymentReportDTO
   */
  orderId?: OrderRefOptional;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentDescription?: string;
}

export interface PaymentReportDTO
  extends
    PaymentReportDTOOptional,
    DBHistory,
    OrderPaymentBase,
    OrderPaymentRef,
    OrderPaymentWithOrderRef,
    ReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof PaymentReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof PaymentReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof PaymentReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof PaymentReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof PaymentReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  createdBy?: string;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentReportDTO
   */
  paymentType: PaymentType;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof PaymentReportDTO
   */
  paymentStatus: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof PaymentReportDTO
   */
  expiresOn?: Date;
  /**
   *
   * @type {OrderRef}
   * @memberof PaymentReportDTO
   */
  orderId: OrderRef;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentDescription?: string;
}

export interface PaymentReportDTOTrackedI extends DBHistoryOptional {
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof PaymentReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof PaymentReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof PaymentReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof PaymentReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof PaymentReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentServiceChangeCents?: number;
  paymentServiceChangeCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentCapturableCents?: number;
  paymentCapturableCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentCapturableDate?: Date;
  paymentCapturableDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentPaidCents?: number;
  paymentPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentTotalCents?: number;
  paymentTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentRefundedCents?: number;
  paymentRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentReportDTO
   */
  paymentToRefundCents?: number;
  paymentToRefundCentsIsSet: boolean;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentReportDTO
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentRecordId?: string;
  paymentRecordIdIsSet: boolean;
  /**
   *
   * @type {PaymentStatus}
   * @memberof PaymentReportDTO
   */
  paymentStatus?: PaymentStatus;
  paymentStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentDueDate?: Date;
  paymentDueDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentPaidDate?: Date;
  paymentPaidDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  squarePaymentId?: string;
  squarePaymentIdIsSet: boolean;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof PaymentReportDTO
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
  /**
   *
   * @type {OrderRef}
   * @memberof PaymentReportDTO
   */
  orderId?: OrderRefTrackedI;
  orderIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentReportDTO
   */
  paymentDescription?: string;
  paymentDescriptionIsSet: boolean;
}

transformDatesMap.set("PaymentReportDTO", function (model: PaymentReportDTO) {
  const transformDateschildReports = transformDatesMap.get("ReportDTO");
  if (transformDateschildReports) {
    model.childReports?.forEach((sub) => {
      transformDateschildReports(sub);
    });
  }
  const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
  if (transformDatesmeta) {
    model.meta?.forEach((sub) => {
      transformDatesmeta(sub);
    });
  }
  const transformDatestypeCounts = transformDatesMap.get("ReportTypeCountDTO");
  if (transformDatestypeCounts) {
    model.typeCounts?.forEach((sub) => {
      transformDatestypeCounts(sub);
    });
  }
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
  if (typeof model.paymentCapturableDate == "string")
    model.paymentCapturableDate = new Date(model.paymentCapturableDate);
  if (typeof model.paymentDueDate == "string")
    model.paymentDueDate = new Date(model.paymentDueDate);
  if (typeof model.paymentPaidDate == "string")
    model.paymentPaidDate = new Date(model.paymentPaidDate);
  if (typeof model.expiresOn == "string")
    model.expiresOn = new Date(model.expiresOn);
  const transformDatesorderId = transformDatesMap.get("OrderRef");
  if (transformDatesorderId && model.orderId) {
    transformDatesorderId(model.orderId);
  }
});

export type PaymentReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  paymentCapturableDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  paymentRecordId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  paymentStatus: PropertyMeta<PaymentStatusMetaI>;
  //isDate: false
  //isDatetime: true
  paymentDueDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  paymentPaidDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  squarePaymentId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  orderId: PropertyMeta<OrderRefMetaI>;
  //isDate: false
  //isDatetime: false
  paymentDescription: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PaymentReportDTOMeta: PaymentReportDTOMetaI =
  {} as PaymentReportDTOMetaI;
PaymentReportDTOMeta = typeMeta("PaymentReportDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  paymentServiceChangeCents: propertyMeta(
    "paymentServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableCents: propertyMeta(
    "paymentCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableDate: propertyMeta(
    "paymentCapturableDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidCents: propertyMeta(
    "paymentPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentTotalCents: propertyMeta(
    "paymentTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentRefundedCents: propertyMeta(
    "paymentRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentToRefundCents: propertyMeta(
    "paymentToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentType: propertyMeta("paymentType", false, true, false, PaymentTypeMeta),
  paymentRecordId: propertyMeta(
    "paymentRecordId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  paymentStatus: propertyMeta(
    "paymentStatus",
    false,
    true,
    false,
    PaymentStatusMeta,
  ),
  paymentDueDate: propertyMeta(
    "paymentDueDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidDate: propertyMeta(
    "paymentPaidDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  squarePaymentId: propertyMeta(
    "squarePaymentId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
  orderId: propertyMeta("orderId", false, true, false, OrderRefMeta),
  paymentDescription: propertyMeta(
    "paymentDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PaymentReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentRefMeta]);
  metaI.assignId.inheritedFrom = OrderPaymentRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentBaseMeta]);
  metaI.paymentServiceChangeCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentServiceChangeCents;
  metaI.paymentCapturableCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentCapturableCents;
  metaI.paymentCapturableDate.inheritedFrom =
    OrderPaymentBaseMeta.paymentCapturableDate;
  metaI.paymentPaidCents.inheritedFrom = OrderPaymentBaseMeta.paymentPaidCents;
  metaI.paymentTotalCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentTotalCents;
  metaI.paymentRefundedCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentRefundedCents;
  metaI.paymentToRefundCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentToRefundCents;
  metaI.paymentType.inheritedFrom = OrderPaymentBaseMeta.paymentType;
  metaI.paymentRecordId.inheritedFrom = OrderPaymentBaseMeta.paymentRecordId;
  metaI.paymentStatus.inheritedFrom = OrderPaymentBaseMeta.paymentStatus;
  metaI.paymentDueDate.inheritedFrom = OrderPaymentBaseMeta.paymentDueDate;
  metaI.paymentPaidDate.inheritedFrom = OrderPaymentBaseMeta.paymentPaidDate;
  metaI.squarePaymentId.inheritedFrom = OrderPaymentBaseMeta.squarePaymentId;
  metaI.expiresOn.inheritedFrom = OrderPaymentBaseMeta.expiresOn;
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentWithOrderRefMeta]);
  metaI.orderId.inheritedFrom = OrderPaymentWithOrderRefMeta.orderId;
});

export class PaymentReportDTOTracked
  extends DBHistoryTracked
  implements PaymentReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  paymentServiceChangeCents__I?: number = undefined;
  paymentServiceChangeCentsIsSet: boolean = false;
  set paymentServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentServiceChangeCents__I = v;
      this.paymentServiceChangeCentsIsSet = true;
    } else {
      this.paymentServiceChangeCents__I = v || undefined;
      this.paymentServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentServiceChangeCents() {
    return this.paymentServiceChangeCents__I;
  }
  paymentCapturableCents__I?: number = undefined;
  paymentCapturableCentsIsSet: boolean = false;
  set paymentCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentCapturableCents__I = v;
      this.paymentCapturableCentsIsSet = true;
    } else {
      this.paymentCapturableCents__I = v || undefined;
      this.paymentCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableCents() {
    return this.paymentCapturableCents__I;
  }
  paymentCapturableDate__I?: Date = undefined;
  paymentCapturableDateIsSet: boolean = false;
  set paymentCapturableDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentCapturableDate__I = v;
      this.paymentCapturableDateIsSet = true;
    } else {
      this.paymentCapturableDate__I = v || undefined;
      this.paymentCapturableDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableDate() {
    return this.paymentCapturableDate__I;
  }
  paymentPaidCents__I?: number = undefined;
  paymentPaidCentsIsSet: boolean = false;
  set paymentPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentPaidCents__I = v;
      this.paymentPaidCentsIsSet = true;
    } else {
      this.paymentPaidCents__I = v || undefined;
      this.paymentPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidCents() {
    return this.paymentPaidCents__I;
  }
  paymentTotalCents__I?: number = undefined;
  paymentTotalCentsIsSet: boolean = false;
  set paymentTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentTotalCents__I = v;
      this.paymentTotalCentsIsSet = true;
    } else {
      this.paymentTotalCents__I = v || undefined;
      this.paymentTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTotalCents() {
    return this.paymentTotalCents__I;
  }
  paymentRefundedCents__I?: number = undefined;
  paymentRefundedCentsIsSet: boolean = false;
  set paymentRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentRefundedCents__I = v;
      this.paymentRefundedCentsIsSet = true;
    } else {
      this.paymentRefundedCents__I = v || undefined;
      this.paymentRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRefundedCents() {
    return this.paymentRefundedCents__I;
  }
  paymentToRefundCents__I?: number = undefined;
  paymentToRefundCentsIsSet: boolean = false;
  set paymentToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentToRefundCents__I = v;
      this.paymentToRefundCentsIsSet = true;
    } else {
      this.paymentToRefundCents__I = v || undefined;
      this.paymentToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentToRefundCents() {
    return this.paymentToRefundCents__I;
  }
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  paymentRecordId__I?: string = undefined;
  paymentRecordIdIsSet: boolean = false;
  set paymentRecordId(v: undefined | string) {
    if (v !== undefined) {
      this.paymentRecordId__I = v;
      this.paymentRecordIdIsSet = true;
    } else {
      this.paymentRecordId__I = v || undefined;
      this.paymentRecordIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRecordId() {
    return this.paymentRecordId__I;
  }
  paymentStatus__I?: PaymentStatus = undefined;
  paymentStatusIsSet: boolean = false;
  set paymentStatus(v: undefined | PaymentStatus) {
    if (v !== undefined) {
      this.paymentStatus__I = v;
      this.paymentStatusIsSet = true;
    } else {
      this.paymentStatus__I = v || undefined;
      this.paymentStatusIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentStatus() {
    return this.paymentStatus__I;
  }
  paymentDueDate__I?: Date = undefined;
  paymentDueDateIsSet: boolean = false;
  set paymentDueDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentDueDate__I = v;
      this.paymentDueDateIsSet = true;
    } else {
      this.paymentDueDate__I = v || undefined;
      this.paymentDueDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentDueDate() {
    return this.paymentDueDate__I;
  }
  paymentPaidDate__I?: Date = undefined;
  paymentPaidDateIsSet: boolean = false;
  set paymentPaidDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentPaidDate__I = v;
      this.paymentPaidDateIsSet = true;
    } else {
      this.paymentPaidDate__I = v || undefined;
      this.paymentPaidDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidDate() {
    return this.paymentPaidDate__I;
  }
  squarePaymentId__I?: string = undefined;
  squarePaymentIdIsSet: boolean = false;
  set squarePaymentId(v: undefined | string) {
    if (v !== undefined) {
      this.squarePaymentId__I = v;
      this.squarePaymentIdIsSet = true;
    } else {
      this.squarePaymentId__I = v || undefined;
      this.squarePaymentIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squarePaymentId() {
    return this.squarePaymentId__I;
  }
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  orderId__I?: OrderRefTracked = undefined;
  orderIdIsSet: boolean = false;
  set orderId(v: undefined | OrderRefTracked) {
    if (v !== undefined) {
      this.orderId__I = v;
      this.orderIdIsSet = true;
    } else {
      this.orderId__I = v || undefined;
      this.orderIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get orderId() {
    return this.orderId__I;
  }
  paymentDescription__I?: string = undefined;
  paymentDescriptionIsSet: boolean = false;
  set paymentDescription(v: undefined | string) {
    if (v !== undefined) {
      this.paymentDescription__I = v;
      this.paymentDescriptionIsSet = true;
    } else {
      this.paymentDescription__I = v || undefined;
      this.paymentDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentDescription() {
    return this.paymentDescription__I;
  }
  constructor(config?: PaymentReportDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.orderId?.setIds();
  }
  assignFrom(
    config: PaymentReportDTOOptional,
    options?: AssignOptions,
  ): PaymentReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.paymentServiceChangeCents &&
      this.paymentServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentServiceChangeCents = config.paymentServiceChangeCents;
      if (optionsRequired.unassign) this.paymentServiceChangeCentsIsSet = false;
      else this.paymentServiceChangeCentsIsSet = true;
    }
    if (
      config.paymentCapturableCents &&
      this.paymentCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableCents = config.paymentCapturableCents;
      if (optionsRequired.unassign) this.paymentCapturableCentsIsSet = false;
      else this.paymentCapturableCentsIsSet = true;
    }
    if (
      config.paymentCapturableDate &&
      this.paymentCapturableDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableDate = config.paymentCapturableDate;
      if (optionsRequired.unassign) this.paymentCapturableDateIsSet = false;
      else this.paymentCapturableDateIsSet = true;
    }
    if (
      config.paymentPaidCents &&
      this.paymentPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidCents = config.paymentPaidCents;
      if (optionsRequired.unassign) this.paymentPaidCentsIsSet = false;
      else this.paymentPaidCentsIsSet = true;
    }
    if (
      config.paymentTotalCents &&
      this.paymentTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTotalCents = config.paymentTotalCents;
      if (optionsRequired.unassign) this.paymentTotalCentsIsSet = false;
      else this.paymentTotalCentsIsSet = true;
    }
    if (
      config.paymentRefundedCents &&
      this.paymentRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRefundedCents = config.paymentRefundedCents;
      if (optionsRequired.unassign) this.paymentRefundedCentsIsSet = false;
      else this.paymentRefundedCentsIsSet = true;
    }
    if (
      config.paymentToRefundCents &&
      this.paymentToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentToRefundCents = config.paymentToRefundCents;
      if (optionsRequired.unassign) this.paymentToRefundCentsIsSet = false;
      else this.paymentToRefundCentsIsSet = true;
    }
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.paymentRecordId &&
      this.paymentRecordIdApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRecordId = config.paymentRecordId;
      if (optionsRequired.unassign) this.paymentRecordIdIsSet = false;
      else this.paymentRecordIdIsSet = true;
    }
    if (
      config.paymentStatus &&
      this.paymentStatusApplyFilter(optionsRequired.filter)
    ) {
      this.paymentStatus = config.paymentStatus;
      if (optionsRequired.unassign) this.paymentStatusIsSet = false;
      else this.paymentStatusIsSet = true;
    }
    if (
      config.paymentDueDate &&
      this.paymentDueDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentDueDate = config.paymentDueDate;
      if (optionsRequired.unassign) this.paymentDueDateIsSet = false;
      else this.paymentDueDateIsSet = true;
    }
    if (
      config.paymentPaidDate &&
      this.paymentPaidDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidDate = config.paymentPaidDate;
      if (optionsRequired.unassign) this.paymentPaidDateIsSet = false;
      else this.paymentPaidDateIsSet = true;
    }
    if (
      config.squarePaymentId &&
      this.squarePaymentIdApplyFilter(optionsRequired.filter)
    ) {
      this.squarePaymentId = config.squarePaymentId;
      if (optionsRequired.unassign) this.squarePaymentIdIsSet = false;
      else this.squarePaymentIdIsSet = true;
    }
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (config.orderId && this.orderIdApplyFilter(optionsRequired.filter)) {
      this.orderId = new OrderRefTracked(config.orderId, options);
      if (optionsRequired.unassign) this.orderIdIsSet = false;
      else this.orderIdIsSet = true;
    }
    if (
      config.paymentDescription &&
      this.paymentDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.paymentDescription = config.paymentDescription;
      if (optionsRequired.unassign) this.paymentDescriptionIsSet = false;
      else this.paymentDescriptionIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PaymentReportDTOTrackedI {
    const cloned = {} as PaymentReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.paymentServiceChangeCentsIsSetDeep() &&
      this.paymentServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentServiceChangeCentsIsSet = true;
      cloned.paymentServiceChangeCents = this.paymentServiceChangeCents;
    } else {
      //cloned.paymentServiceChangeCentsIsSet = false
    }
    if (
      this.paymentCapturableCentsIsSetDeep() &&
      this.paymentCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableCentsIsSet = true;
      cloned.paymentCapturableCents = this.paymentCapturableCents;
    } else {
      //cloned.paymentCapturableCentsIsSet = false
    }
    if (
      this.paymentCapturableDateIsSetDeep() &&
      this.paymentCapturableDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableDateIsSet = true;
      cloned.paymentCapturableDate = this.paymentCapturableDate;
    } else {
      //cloned.paymentCapturableDateIsSet = false
    }
    if (
      this.paymentPaidCentsIsSetDeep() &&
      this.paymentPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidCentsIsSet = true;
      cloned.paymentPaidCents = this.paymentPaidCents;
    } else {
      //cloned.paymentPaidCentsIsSet = false
    }
    if (
      this.paymentTotalCentsIsSetDeep() &&
      this.paymentTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTotalCentsIsSet = true;
      cloned.paymentTotalCents = this.paymentTotalCents;
    } else {
      //cloned.paymentTotalCentsIsSet = false
    }
    if (
      this.paymentRefundedCentsIsSetDeep() &&
      this.paymentRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRefundedCentsIsSet = true;
      cloned.paymentRefundedCents = this.paymentRefundedCents;
    } else {
      //cloned.paymentRefundedCentsIsSet = false
    }
    if (
      this.paymentToRefundCentsIsSetDeep() &&
      this.paymentToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentToRefundCentsIsSet = true;
      cloned.paymentToRefundCents = this.paymentToRefundCents;
    } else {
      //cloned.paymentToRefundCentsIsSet = false
    }
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.paymentRecordIdIsSetDeep() &&
      this.paymentRecordIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRecordIdIsSet = true;
      cloned.paymentRecordId = this.paymentRecordId;
    } else {
      //cloned.paymentRecordIdIsSet = false
    }
    if (
      this.paymentStatusIsSetDeep() &&
      this.paymentStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentStatusIsSet = true;
      cloned.paymentStatus = this.paymentStatus;
    } else {
      //cloned.paymentStatusIsSet = false
    }
    if (
      this.paymentDueDateIsSetDeep() &&
      this.paymentDueDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentDueDateIsSet = true;
      cloned.paymentDueDate = this.paymentDueDate;
    } else {
      //cloned.paymentDueDateIsSet = false
    }
    if (
      this.paymentPaidDateIsSetDeep() &&
      this.paymentPaidDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidDateIsSet = true;
      cloned.paymentPaidDate = this.paymentPaidDate;
    } else {
      //cloned.paymentPaidDateIsSet = false
    }
    if (
      this.squarePaymentIdIsSetDeep() &&
      this.squarePaymentIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squarePaymentIdIsSet = true;
      cloned.squarePaymentId = this.squarePaymentId;
    } else {
      //cloned.squarePaymentIdIsSet = false
    }
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    if (
      this.orderIdIsSetDeep() &&
      this.orderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderIdIsSet = true;
      cloned.orderId = this.orderId?.removeUnset(filter);
    } else {
      //cloned.orderIdIsSet = false
    }
    if (
      this.paymentDescriptionIsSetDeep() &&
      this.paymentDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentDescriptionIsSet = true;
      cloned.paymentDescription = this.paymentDescription;
    } else {
      //cloned.paymentDescriptionIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PaymentReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.paymentServiceChangeCentsApplyFilter(filter))
      this.paymentServiceChangeCentsIsSet = false;

    if (!this.paymentCapturableCentsApplyFilter(filter))
      this.paymentCapturableCentsIsSet = false;

    if (!this.paymentCapturableDateApplyFilter(filter))
      this.paymentCapturableDateIsSet = false;

    if (!this.paymentPaidCentsApplyFilter(filter))
      this.paymentPaidCentsIsSet = false;

    if (!this.paymentTotalCentsApplyFilter(filter))
      this.paymentTotalCentsIsSet = false;

    if (!this.paymentRefundedCentsApplyFilter(filter))
      this.paymentRefundedCentsIsSet = false;

    if (!this.paymentToRefundCentsApplyFilter(filter))
      this.paymentToRefundCentsIsSet = false;

    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.paymentRecordIdApplyFilter(filter))
      this.paymentRecordIdIsSet = false;

    if (!this.paymentStatusApplyFilter(filter)) this.paymentStatusIsSet = false;

    if (!this.paymentDueDateApplyFilter(filter))
      this.paymentDueDateIsSet = false;

    if (!this.paymentPaidDateApplyFilter(filter))
      this.paymentPaidDateIsSet = false;

    if (!this.squarePaymentIdApplyFilter(filter))
      this.squarePaymentIdIsSet = false;

    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    if (!this.orderIdApplyFilter(filter)) this.orderIdIsSet = false;
    this.orderId?.unassignAll(filter);

    if (!this.paymentDescriptionApplyFilter(filter))
      this.paymentDescriptionIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.isDeleted,
      PaymentReportDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.isNew,
      PaymentReportDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.reportId,
      PaymentReportDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.reportKey,
      PaymentReportDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.reportTitle,
      PaymentReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.reportType,
      PaymentReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.reportStatus,
      PaymentReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.childReports,
      PaymentReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.meta,
      PaymentReportDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.typeCounts,
      PaymentReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.updatedOn,
      PaymentReportDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.updatedBy,
      PaymentReportDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.createdOn,
      PaymentReportDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.createdBy,
      PaymentReportDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.assignId,
      PaymentReportDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  paymentServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentServiceChangeCents,
      PaymentReportDTOMeta,
      this.paymentServiceChangeCents,
      this,
    );
  }
  paymentServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentServiceChangeCentsIsSet &&
      this.paymentServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentCapturableCents,
      PaymentReportDTOMeta,
      this.paymentCapturableCents,
      this,
    );
  }
  paymentCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableCentsIsSet &&
      this.paymentCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentCapturableDate,
      PaymentReportDTOMeta,
      this.paymentCapturableDate,
      this,
    );
  }
  paymentCapturableDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableDateIsSet &&
      this.paymentCapturableDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentPaidCents,
      PaymentReportDTOMeta,
      this.paymentPaidCents,
      this,
    );
  }
  paymentPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidCentsIsSet && this.paymentPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  paymentTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentTotalCents,
      PaymentReportDTOMeta,
      this.paymentTotalCents,
      this,
    );
  }
  paymentTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTotalCentsIsSet &&
      this.paymentTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentRefundedCents,
      PaymentReportDTOMeta,
      this.paymentRefundedCents,
      this,
    );
  }
  paymentRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentRefundedCentsIsSet &&
      this.paymentRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentToRefundCents,
      PaymentReportDTOMeta,
      this.paymentToRefundCents,
      this,
    );
  }
  paymentToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentToRefundCentsIsSet &&
      this.paymentToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentType,
      PaymentReportDTOMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  paymentRecordIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentRecordId,
      PaymentReportDTOMeta,
      this.paymentRecordId,
      this,
    );
  }
  paymentRecordIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentRecordIdIsSet && this.paymentRecordIdApplyFilter(filter))
      return true;

    return false;
  }
  paymentStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentStatus,
      PaymentReportDTOMeta,
      this.paymentStatus,
      this,
    );
  }
  paymentStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentStatusIsSet && this.paymentStatusApplyFilter(filter))
      return true;

    return false;
  }
  paymentDueDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentDueDate,
      PaymentReportDTOMeta,
      this.paymentDueDate,
      this,
    );
  }
  paymentDueDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentDueDateIsSet && this.paymentDueDateApplyFilter(filter))
      return true;

    return false;
  }
  paymentPaidDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentPaidDate,
      PaymentReportDTOMeta,
      this.paymentPaidDate,
      this,
    );
  }
  paymentPaidDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidDateIsSet && this.paymentPaidDateApplyFilter(filter))
      return true;

    return false;
  }
  squarePaymentIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.squarePaymentId,
      PaymentReportDTOMeta,
      this.squarePaymentId,
      this,
    );
  }
  squarePaymentIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squarePaymentIdIsSet && this.squarePaymentIdApplyFilter(filter))
      return true;

    return false;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.expiresOn,
      PaymentReportDTOMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  orderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.orderId,
      PaymentReportDTOMeta,
      this.orderId,
      this,
    );
  }
  orderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderIdIsSet && this.orderIdApplyFilter(filter)) return true;
    return this.orderId?.anySet(filter) == true;

    return false;
  }
  paymentDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentReportDTOMeta.paymentDescription,
      PaymentReportDTOMeta,
      this.paymentDescription,
      this,
    );
  }
  paymentDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentDescriptionIsSet &&
      this.paymentDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.paymentServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableDateIsSetDeep(filter)) return true;
    if (this.paymentPaidCentsIsSetDeep(filter)) return true;
    if (this.paymentTotalCentsIsSetDeep(filter)) return true;
    if (this.paymentRefundedCentsIsSetDeep(filter)) return true;
    if (this.paymentToRefundCentsIsSetDeep(filter)) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.paymentRecordIdIsSetDeep(filter)) return true;
    if (this.paymentStatusIsSetDeep(filter)) return true;
    if (this.paymentDueDateIsSetDeep(filter)) return true;
    if (this.paymentPaidDateIsSetDeep(filter)) return true;
    if (this.squarePaymentIdIsSetDeep(filter)) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    if (this.orderIdIsSetDeep(filter)) return true;
    if (this.paymentDescriptionIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
